module.exports = __webpack_public_path__ + "assets/img/8_1769.8d5c1775.jpg";